import type { TranslationKey } from '../../i18n/en'

// Findings #183: the lot form showed the server's English refusals as they
// came ("A lot named "26SETE1" already exists…"). The ones a move can hit read
// in Spanish; anything else is still shown as sent.
const MOVE_ERRORS: Array<[RegExp, TranslationKey]> = [
  [/already exists in (this|one of the chosen) production unit/i, 'lots.move.error.nameTaken'],
  [/move date is in the future/i, 'lots.move.error.future'],
  [/move date is before lot .* arrived/i, 'lots.move.error.beforeArrival'],
  [/Fish can only join|must be active in both units|Choose a different lot to move/i, 'lots.move.error.sameLotInvalid']
]

export const moveErrorKey = (message: string): TranslationKey | null => {
  for (const [pattern, key] of MOVE_ERRORS) {
    if (pattern.test(message)) return key
  }
  return null
}
